'use strict';

var _ = require('lodash');
var tooltipTemplateHtml = require('../templates/demand-posting-breakdown-info-tooltip.html');
var DemandPostingBreakdownModalDirective = function DemandPostingBreakdownModalDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/demand-posting-breakdown-modal.html'),
    controller: 'DemandPostingBreakdownModalController',
    scope: {
      gridParams: '=',
      dimension: '='
    },
    link: function link($scope, $element) {
      $scope.closeModal = function () {
        $element.modal('hide');
      };
      $scope.$on('demand-posting:open-breakdown-modal', function (event, operationData) {
        $scope.initModal(operationData);
        $scope.updateTooltipContent();
        $element.modal('show');
      });
      var infoIcon = $element.find('.dp-info-icon');
      infoIcon.popover({
        html: true,
        trigger: 'focus',
        placement: 'bottom',
        container: '.dp-info-icon.fa.fa-info-circle'
      });
      $scope.updateTooltipContent = function () {
        var tooltipContentTemplate = _.template(tooltipTemplateHtml);
        var popover = infoIcon.data('bs.popover');
        if (popover) {
          popover.options.content = tooltipContentTemplate({
            sourceClassGroup: $scope.sourceClassGroup,
            adjMode: $scope.adjMode,
            adjAmount: $scope.adjAmount,
            targetClassGroup: $scope.targetClassGroup
          }).replace(/>\s*</g, '><');
          popover.setContent();
        }
      };
      $scope.$on('$destroy', function () {
        infoIcon.popover('destroy');
      });
    }
  };
};
DemandPostingBreakdownModalDirective.$inject = [];
module.exports = DemandPostingBreakdownModalDirective;